/**
 * Utility functions for date formatting and conversion
 */

/**
 * Function to convert UTC date to local timezone with specific format yyyy-MM-dd HH:mm
 * @param {Date|String} utcDateValue - The UTC date to convert
 * @returns {String} - Formatted date string in local timezone
 */
export const formatUTCtoLocal = (utcDateValue) => {
    if (!utcDateValue) return '';
    
    try {
      // Convert to ISO string if it's a Date object
      const dateStr = utcDateValue instanceof Date 
        ? utcDateValue.toISOString() 
        : String(utcDateValue);
      
      // Parse date components from ISO string
      const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
      
      if (!match) return dateStr; // Return original if format doesn't match
      
      // Create a date object specifically marking these components as UTC
      const utcDate = new Date(Date.UTC(
        parseInt(match[1]), // year
        parseInt(match[2]) - 1, // month (0-indexed)
        parseInt(match[3]), // day
        parseInt(match[4]), // hour
        parseInt(match[5]), // minute
        parseInt(match[6])  // second
      ));
      
      // Format to yyyy-MM-dd HH:mm
      const localYear = utcDate.getFullYear();
      const localMonth = String(utcDate.getMonth() + 1).padStart(2, '0');
      const localDay = String(utcDate.getDate()).padStart(2, '0');
      const localHours = String(utcDate.getHours()).padStart(2, '0');
      const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
      
      return `${localYear}-${localMonth}-${localDay} ${localHours}:${localMinutes}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return String(utcDateValue); // Fallback to original value
    }
  };
  
  /**
   * Component for rendering a local datetime in a DataGrid cell
   * @param {Object} cellData - The cell data from DevExtreme DataGrid
   * @returns {String} - Formatted date string
   */
  export const renderLocalDateTime = (cellData) => {
    return formatUTCtoLocal(cellData.value);
  };